<template>
    <div>
        <header>
            <div class="container">
                <div class="left-logo">
                    <router-link :to="getHomeLink">
                        <img src="/static/commercial/img/logo-eremit.png" alt="">
                    </router-link>
                </div>
                <div class="right-nav">
                    <ul class="menus">
                        <li :key="menu.url" v-for="menu in getMenus">
                            <router-link :to="menu.url">
                                {{menu.title}}
                            </router-link>
                        </li>
                    </ul>

                    <ul class="login-detail">
                        <div v-if="$route.meta.pagetype===2">
                                <li class="login">
                                <a href="https://www.bizpayments.com.my/account/login">Login</a>
                            </li>
                            <li class="sign-up">
                                <a href="https://www.bizpayments.com.my/account/register" class="border-btn">Sign Up</a>
                            </li>
                        </div>
                        <div v-else>
                            <li class="login">
                                <router-link :to="'/account/login'">Login</router-link>
                            </li>
                            <li class="sign-up">
                                <router-link :to="'/account/registration/initial'" class="border-btn">Sign Up</router-link>
                            </li>
                        </div>
                    </ul>
                    <ul>
                        <li class="icon">
                            <span style="font-size:30px;cursor:pointer" @click="openNav">&#9776;</span>
                        </li>
                    </ul>
                </div>
                <!-- eo right nav -->
            </div>
            <!-- eo container -->
        </header>
        <div id="mySidenav" class="overlay" ref="mySidenav">
            <a href="javascript:void(0)" class="closebtn" @click="closeNav">&times;</a>
            <div class="overlay-content">
                <!-- <router-link :to="'/rate'">Today's Rates</router-link>
                <router-link :to="'/works'">How it works</router-link>
                <router-link :to="'/business'">For Business</router-link> -->
                <router-link
                :key="menu.url"
                v-for="menu in getMenus"
                 :to="menu.url">{{menu.title}}</router-link>
                 <div v-if="$route.meta.pagetype===2">
                    <a href="https://www.bizpayments.com.my/account/login">Login</a>
                    <a href="https://www.bizpayments.com.my/account/register">Sign Up</a>
                </div>
                <div v-else>
                 <router-link :to="'/account/login'">Login</router-link>

                 <router-link :to="'/account/registration/initial'">Sign Up</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "Hamburger",
  created() {},
  data() {
    return {
      vModel: {
        RecipientId: null
      }
    };
  },
  computed: {
    getHomeLink() {
      if ((this.$route.meta.pagetype || 1) === 1) {
        return "/";
      }
      return "/business";
    },
    getMenus() {
      if ((this.$route.meta.pagetype || 1) === 1) {
        return [
            // {
            //     title: "Today's Rates",
            //     url: '/rate'
            // },
          {
            title: "How it works",
            url: "/works"
          },
          {
            title: "For Business",
            url: "/business"
          }
        ];
      } else
        return [
          {
            title: "How it works",
            url: "/worksbiz"
          },
          {
            title: "For Personal",
            url: "/"
          }
        ];
    }
  },
  methods: {
    openNav: function() {
      var body = document.querySelector("body");
      body.classList.add("overflow-hidden");

      const el = this.$refs.mySidenav;
      el.classList.add("sidenav-full-width");
    },
    closeNav: function() {
      var body = document.querySelector("body");
      body.classList.remove("overflow-hidden");
      const el = this.$refs.mySidenav;
      el.classList.remove("sidenav-full-width");
    }
  }
};
</script>
